import { pascalCase as r, pascalCaseTransformMerge as t } from "pascal-case";
import { camelCase as n, camelCaseTransformMerge as e } from "camel-case";

function o() {
  return (o = Object.assign || function (r) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];

      for (var e in n) {
        Object.prototype.hasOwnProperty.call(n, e) && (r[e] = n[e]);
      }
    }

    return r;
  }).apply(this, arguments);
}

function a(r, t) {
  (null == t || t > r.length) && (t = r.length);

  for (var n = 0, e = new Array(t); n < t; n++) {
    e[n] = r[n];
  }

  return e;
}

var i = function i() {
  return r([].slice.call(arguments).filter(function (r) {
    return null != r;
  }).join(" "), {
    transform: t
  });
},
    c = function c() {
  return n([].slice.call(arguments).filter(function (r) {
    return null != r;
  }).join(" "), {
    transform: e
  });
},
    l = function l(r) {
  return Array.isArray(r) ? r : [r];
},
    u = ["id", "internal", "fields", "parent", "children"],
    f = function f(r) {
  var t = r.typePrefix,
      n = r.fieldPrefix,
      e = void 0 === n ? t : n,
      f = r.createNodeId,
      s = r.createContentDigest,
      d = function d(r) {
    return i.apply(void 0, [t].concat(l(r)));
  },
      p = function p(r) {
    return c.apply(void 0, [e].concat(l(r)));
  },
      y = function y(r) {
    return f([t].concat(l(r)).filter(function (r) {
      return null != r;
    }).join(" "));
  };

  return {
    createTypeName: d,
    createFieldName: p,
    createNodeId: y,
    createNodeFactory: function createNodeFactory(r, t) {
      var n = (void 0 === t ? {} : t).idIsGloballyUnique,
          e = void 0 !== n && n;
      return function (t) {
        for (var n, i = y(e ? t.id.toString() : [].concat(l(r), [t.id.toString()])), c = o({}, t, {
          id: i,
          internal: {
            type: d(r),
            contentDigest: s(t)
          }
        }), f = function (r, t) {
          var n;

          if ("undefined" == typeof Symbol || null == r[Symbol.iterator]) {
            if (Array.isArray(r) || (n = function (r, t) {
              if (r) {
                if ("string" == typeof r) return a(r, t);
                var n = Object.prototype.toString.call(r).slice(8, -1);
                return "Object" === n && r.constructor && (n = r.constructor.name), "Map" === n || "Set" === n ? Array.from(r) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? a(r, t) : void 0;
              }
            }(r))) {
              n && (r = n);
              var e = 0;
              return function () {
                return e >= r.length ? {
                  done: !0
                } : {
                  done: !1,
                  value: r[e++]
                };
              };
            }

            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }

          return (n = r[Symbol.iterator]()).next.bind(n);
        }(u); !(n = f()).done;) {
          var v = n.value;
          v in t && (c[p(v)] = t[v]);
        }

        return c;
      };
    }
  };
};

export { f as createNodeHelpers };